import Offcanvas from 'react-bootstrap/Offcanvas';

import './style.scss';
import { EssentialRightPanelContent } from 'routes/essential-workspace/components/right-panel/content';
import Footer from 'routes/essential-workspace/components/right-panel/footer';

import { Header } from './header';

type EssentialRightPanelProps = {
  isOpen: boolean;
  toggleSidePanel: () => void;
  currentSectionId: string;
  setCurrentSection: (sectionId: string) => void;
};

export function EssentialRightPanel({
  isOpen: isSidePanelOpened,
  toggleSidePanel,
  currentSectionId,
  setCurrentSection,
}: EssentialRightPanelProps) {
  return (
    <Offcanvas
      placement="end"
      role="complementary"
      className="border-start border-opacity-70 shadow-none essential-side-panel"
      show={isSidePanelOpened}
      aria-hidden={!isSidePanelOpened}
      aria-label="Custom layout"
      onHide={toggleSidePanel}
      backdrop={false}
      scroll={false}
      enforceFocus={false}
    >
      <Header toggleSidePanel={toggleSidePanel} />
      <Offcanvas.Body className="px-3 overflow-auto scrollbar-sm">
        <EssentialRightPanelContent
          currentSectionId={currentSectionId}
          setCurrentSection={setCurrentSection}
          closePanel={toggleSidePanel}
        />
      </Offcanvas.Body>
      <Footer currentSectionId={currentSectionId} setCurrentSection={setCurrentSection} closePanel={toggleSidePanel} />
    </Offcanvas>
  );
}
